import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledGlimmerIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.85742 4.01611C6.95207 4.29159 7.16207 4.5127 7.43262 4.62061L10.7988 5.96143L7.43262 7.30225C7.16208 7.41015 6.95208 7.63126 6.85742 7.90674L5.64941 11.4224L4.44141 7.90674C4.34675 7.63127 4.13675 7.41015 3.86621 7.30225L0.5 5.96143L3.86523 4.62061H3.86621C4.13675 4.5127 4.34675 4.29159 4.44141 4.01611L5.64941 0.500488L6.85742 4.01611Z",
		fill: "white",
		stroke: "#008355"
	})]
});
const ForwardRef = forwardRef(SvgFilledGlimmerIcon);
const Memo = memo(ForwardRef);
export default Memo;
